

















































































import { Component, Vue } from 'vue-property-decorator';
import Loading from '@/components/Loading.vue';
import { ActionNames } from "@/constants/ActionNames";
import validateEmail from "@/utils/validateEmail";
import { validateInputs } from "@/utils/validateInputs";

interface RegisterData {
  firstName: string;
  middleName?: string;
  businessName?: string;
  surName: string;
  email: string;
  password: string;
  license: string;
}

@Component({
  components: {
    Loading,
  },
})
export default class Register extends Vue {
  public selected: string = '';

  public businessName: string = '';

  public loading: boolean = false;

  public error: boolean = false;

  public errorMessage: string = 'Er ging iets fout tijdens het registreren';

  public middleName: string = '';

  public registerData: RegisterData = {
    firstName: '',
    surName: '',
    email: '',
    password: '',
    license: '',
  };

  public async doRegister() {
    this.loading = true;

    if (validateEmail(this.registerData.email) && validateInputs(this.registerData)) {
      this.registerData = {
        ...this.registerData,
        middleName: this.middleName
      };

      if (this.businessName !== '') {
        this.registerData = {
          ...this.registerData,
          businessName: this.businessName
        }
      }

      const success = await this.$store.dispatch(ActionNames.REGISTER, this.registerData);

      if (success) {
        const successLogin = await this.$store.dispatch(ActionNames.LOGIN, {
          email: this.registerData.email,
          password: this.registerData.password,
        });

        if (!successLogin) {
          this.error = true;
          this.errorMessage = 'Er ging iets fout tijdens het registreren';
        }
      } else {
        this.error = true;
        this.errorMessage = 'Er ging iets fout tijdens het registreren';
      }
    } else {
      this.error = true;
      this.errorMessage = 'Vul alle gegevens in';
    }

    this.loading = false;
  }
}
